import React, {FC} from "react"
import PropTypes from "prop-types"

import {injectIntl, InjectIntl} from "@irati/utils/lang"
import Icon from "@irati/ui/src/Icon"
import {H5} from "@irati/ui/src/Typography"
import {Tooltip} from "@irati/ui/src/Tooltip"

import {StyledRouterLink} from "./styled"

interface Context {
  apps: {[key: string]: string}
  appPath: string
}

interface Props extends InjectIntl {
  isCollapsed: boolean
  to: string
  title: string
  icon: string
  onClick: () => void
  app?: string
  id?: string
  ignoreSelected: boolean
}

const AdminRouterLink: FC<Props> = (
  {formatMessage, isCollapsed, to, title, icon, onClick, id, ignoreSelected, app},
  {apps, appPath}: Context
) => {
  const {ADMIN} = apps
  const pathname = window.location.pathname
  const isSelected = pathname === `${appPath}${to}` || pathname.includes(`${appPath}${to}`)

  return (
    <StyledRouterLink
      id={`adminNav_${id}`}
      isSidebarNavigation
      isSelected={!ignoreSelected && isSelected}
      app={app || ADMIN}
      to={to}
      isCentered={isCollapsed}
      onClick={onClick}>
      {icon && !isCollapsed && <Icon icon={icon} size={24} />}
      {icon && isCollapsed && (
        <Tooltip tooltipChildren={formatMessage({id: title})} placement="right">
          <Icon icon={icon} size={24} />
        </Tooltip>
      )}
      {!isCollapsed && (
        <H5 marginLeft={2} weight="bold">
          {formatMessage({id: title})}
        </H5>
      )}
    </StyledRouterLink>
  )
}

AdminRouterLink.contextTypes = {
  apps: PropTypes.object.isRequired,
  appPath: PropTypes.string.isRequired
}

export default injectIntl(AdminRouterLink)
